export default "__VITE_ASSET__wpHFdhlq__"